import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
} from '../index';
import {
  doGetDocumentoComUrlDinamica,
} from '../../utils/requests';

class DownloadItem extends Component {
  constructor() {
    super();
    this.state = {};
  }

  downloadDocument = () => {
    doGetDocumentoComUrlDinamica(this.props.arquivo.id, 'comprovante', this.props.caminho);
  }

  render() {
    if (this.props.arquivo.id) {
      return (
        <div className="row">
          <Grid cols="12 12 12 12">
            {(this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'requerer-compensacao-rpps',
              'analisar-compensacao-rpps'])) ?
                <Button
                  hint={this.props.arquivo.nome}
                  icon="ico-download"
                  onClick={() => this.downloadDocument()}
                />
            :
                <Button
                  hint={this.props.arquivo.nome}
                  icon="ico-cancel-circle"
                />
            }
            <span>{this.props.arquivo.nome}</span>
          </Grid>
        </div>
      );
    }
    return '';
  }
}

DownloadItem.propTypes = {
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  arquivo: PropTypes.shape({
    id: PropTypes.string,
    nome: PropTypes.string,
  }).isRequired,
  caminho: PropTypes.string.isRequired,
};

export default DownloadItem;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/DownloadItem.jsx